import sanityImage from '@sanity/image-url'
import {config} from '@local/config/sanity.mjs'

export const imageBuilder = sanityImage({
	projectId: config.projectId,
	dataset: config.dataset,
})
